import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useStatusFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    status: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ status }) => {
    const statusValue = status.value || 'any';
    setFilters(
      { status: statusValue },
      {
        removeFilters: statusValue === 'any' ? ['status'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useStatusFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
